export default "__VITE_ASSET__BE7_hWeL__"